import type { AvailableShippingMethod } from '~/modules/GraphQL/types';

export default (shippingMethod: AvailableShippingMethod) => {
  const value = shippingMethod?.amount?.value;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const priceWithTax = shippingMethod?.amount_incl_tax?.value;

  return priceWithTax > 0 && priceWithTax > value ? priceWithTax : value;
};
